import * as React from 'react';
import TileImage from '../TileImage';
import TileContent from '../TileContent';
import TileVideo from "../TileVideo";
import { getPadding, getTileClasses } from '../TileMethods';

const Overlayed = ({ data, height, settings, isMobile }) => {
  const paddingContent = getPadding(data);
  const tileClasses = getTileClasses(data, isMobile, paddingContent);

  // Use aspect_ratio_value from settings or fallback to 1 (1:1)
  const aspectRatio = data.settings.aspect_ratio_type;
  const useAspectWrapper = aspectRatio !== 'aspect-auto';
  const aspectRatioValue = typeof aspectRatio === 'number' ? aspectRatio : 1;
  const aspectRatioPercent = `${100 / aspectRatioValue}%`;

  const tileContent = (
    <div className={`tileitem color-${data.color_schema} ${data.settings.padding_area == 'outside' && paddingContent}`}>
   {data.settings.image_or_video === 'video' ? (
                <TileVideo data={data} height={height} isMobile={isMobile} />
            ) : (
                <TileImage data={data} height={height} isMobile={isMobile} />
            )}
      <div className={`tile__info  test 2 ${data.settings.image ? 'flex absolute w-full z-[5]' : ''} ${tileClasses}`}>
        <TileContent
          data={data}
          isMobile={isMobile}
        />
      </div>
    </div>
  );

  // Aspect ratio wrapper for compatibility
  const aspectWrapper = (
    <div style={{ position: 'relative', width: '100%', paddingBottom: aspectRatioPercent }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>{tileContent}</div>
    </div>
  );

  const content = useAspectWrapper ? aspectWrapper : tileContent;

  return (
    <>
      {data.settings.make_tile_clickable ? (
        <div
          onClick={() => (window.location.href = data.settings.button_url)}
          className={`custom-class cursor-pointer`}
        >
          {content}
        </div>
      ) : (
        content
      )}
    </>
  );
};

export default Overlayed;
